import React from "react";
import PinInput from "react-pin-input";

const DEFAULT_PIN_LENGTH = 6;
const DEFAULT_HEIGHT_WIDTH = 50;
const DEFAULT_PIN_FONT_SIZE = 12;

const AuthPin = ({ length = DEFAULT_PIN_LENGTH, onChange, heightWidth = DEFAULT_HEIGHT_WIDTH, fontSize = DEFAULT_PIN_FONT_SIZE }) => (
  <PinInput
    length={length}
    onChange={onChange}
    type="numeric"
    inputMode="number"
    inputStyle={{
      background: "#F5F3F3",
      borderBottom: "1px solid black",
      border: "none",
      width: heightWidth,
      height: heightWidth,
      fontFamily: "Work Sans",
      fontSize
    }}
    onComplete={onChange}
  />
);

export default AuthPin;
